var map = {
	"./asset-hyperlink.json": 59972,
	"./blockquote.json": 78218,
	"./document.json": 94997,
	"./embedded-asset-block.json": 555,
	"./embedded-entry-block.json": 43409,
	"./embedded-entry-inline.json": 63626,
	"./embedded-resource-block.json": 22604,
	"./embedded-resource-inline.json": 73073,
	"./entry-hyperlink.json": 5187,
	"./heading-1.json": 77088,
	"./heading-2.json": 57312,
	"./heading-3.json": 31106,
	"./heading-4.json": 43529,
	"./heading-5.json": 11294,
	"./heading-6.json": 89132,
	"./hr.json": 14441,
	"./hyperlink.json": 34262,
	"./list-item.json": 62289,
	"./ordered-list.json": 19763,
	"./paragraph.json": 15798,
	"./resource-hyperlink.json": 85648,
	"./table-cell.json": 35328,
	"./table-header-cell.json": 61393,
	"./table-row.json": 15405,
	"./table.json": 58200,
	"./text.json": 90518,
	"./unordered-list.json": 10432
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16889;